module.exports = __webpack_public_path__ + "static/img/tabela.7115d9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/frutuba_laranja/tabela.png
// module id = M4is
// module chunks = 0